import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/reports';
import { selectors, DEFAULT_STATE } from '../reducers/reports';
import api from '../apis/reports';

const sagas = helper.createSagas(
    'reports',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
